/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createAbs } from '../../factoriesAny.js';
export var absDependencies = {
  typedDependencies,
  createAbs
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesAbs.generated.js
// module id = 66
// module chunks = 2